import { Injectable } from '@angular/core';
import { FitApiClientService } from '@shared/fit-api-client.service';

export interface ProgramTag {
    id: number;
    name: string;
    description?: string;
    is_custom_tag: boolean;
    items_count?: number;
}

export interface ProgramTagRequest {
    name: string;
    description?: string;
}

@Injectable({ providedIn: 'root' })
export class ProgramTagService {
    constructor(private fitApi: FitApiClientService) {}

    public getAll() {
        return this.fitApi.get<ProgramTag[]>('/admin/tag/program');
    }

    public create(tag: ProgramTagRequest) {
        return this.fitApi.put<ProgramTag>('/admin/tag/program/0', tag);
    }

    public update(id: number, tag: ProgramTagRequest) {
        return this.fitApi.put<ProgramTag>(`/admin/tag/program/${id}`, tag);
    }

    public delete(id: number) {
        return this.fitApi.delete<unknown>(`/admin/tag/${id}`);
    }
}
